import { isDiscreteDataType } from './isDiscreteDataType';

type OnChangeTagInput = {
  dataType?: string;
  statistic?: string | null;
};

/**
 * A tag is fetched/rendered as on-change data if its data type is inherently
 * discrete, or the user explicitly picked the "On-change" statistic.
 */
export const isOnChangeTag = (tag: OnChangeTagInput): boolean =>
  isDiscreteDataType(tag.dataType) || tag.statistic === 'On-change';
